import { useMutation } from "@apollo/react-hooks";
import { Modal, Stack, TextField } from "@shopify/polaris";
import React, { useCallback, useReducer } from "react";
import { UPDATE_ORDER_COST_MANUAL } from "../../graphql/mutations";
import { handleError, reducerFn } from "../../helper";
import useTimeout from "../../hooks/useTimeout";
import { useToastContext } from "../shared/ToastContext";

export default function UpdateCostManual({
    value,
    open,
    onClose,
    refetch,
    handleCompleted,
}) {
    const id = value?.id;
    const [state, setState] = useReducer(reducerFn, {
        baseCost: "",
        shippingCost: "",
    });

    const { setNotify, toggleToast } = useToastContext();

    const [setDelay] = useTimeout();
    const [markOrderSplit, { loading }] = useMutation(
        UPDATE_ORDER_COST_MANUAL,
        {
            onCompleted: () => {
                setNotify({ msg: "Update Cost success", err: false });

                setDelay(() => {
                    onClose && onClose();
                    refetch && refetch();
                    handleCompleted && handleCompleted();
                }, 1500);
            },
            onError: (err) => {
                setNotify({ msg: handleError(err?.toString()), err: true });
            },
        },
    );

    React.useEffect(() => {
        const { shippingCost, baseCost } = value;

        setState({ shippingCost: shippingCost + "", baseCost: baseCost + "" });
    }, [value?.shippingCost, value?.baseCost]);

    const handleSubmit = useCallback(() => {
        if (!id) return;

        markOrderSplit({
            variables: {
                id,
                baseCost: parseFloat(state.baseCost),
                shippingCost: parseFloat(state.shippingCost),
            },
        });
    }, [
        markOrderSplit,
        setNotify,
        toggleToast,
        id,
        state.baseCost,
        state.shippingCost,
    ]);

    const handleStateChange = useCallback((value, id) => {
        setState({ [id]: value });
    }, []);

    return (
        <Modal
            title="Update Cost"
            sectioned
            open={open}
            onClose={onClose}
            secondaryActions={[{ content: "Cancel", onAction: onClose }]}
            primaryAction={{
                content: "Submit",
                onAction: handleSubmit,
                loading: loading,
            }}
        >
            <Stack vertical>
                <TextField
                    id="baseCost"
                    label="Base Cost"
                    placeholder="Enter base cost"
                    onChange={handleStateChange}
                    value={state.baseCost}
                    step={0.1}
                    type="number"
                />
                <TextField
                    id="shippingCost"
                    label="Shipping Cost"
                    placeholder="Enter shipping cost"
                    onChange={handleStateChange}
                    value={state.shippingCost}
                    step={0.1}
                    type="number"
                />
            </Stack>
        </Modal>
    );
}
